import React, { useState } from 'react';
import { InvitationInfo } from '~/interfaces';
import AccountPageLayout from '~envs/mixins/account/containers/account-page-layout';
import NormalLogin from '~/mixins/account/containers/normal-login';
import Register from '../register';
import { SignInProps } from '../../../../interfaces';

const SignIn: React.FC<SignInProps> = (props) => {
    const [invitationList, setInvitationList] = useState<InvitationInfo[]>();
    const [isRegister, setIsRegister] = useState(false);

    if (isRegister) {
        return <Register skipRegister invitations={invitationList} />;
    }

    return (
        <AccountPageLayout
            className="jdy-page-signin"
            showFooter
            showLangSwitch
            mobileAlignCenter
            withSuite
        >
            <NormalLogin
                {...props}
                onRegister={(invitations) => {
                    setIsRegister(true);
                    setInvitationList(invitations);
                }}
            />
        </AccountPageLayout>
    );
};

export default SignIn;
